import Vuex from 'vuex'
import Vue from 'vue';
import CapturaService from "../services/CapturaService";
import jwtDecode from "jwt-decode";

Vue.use(Vuex)


let initialState = {
    URLRETORNO: null,
    chave: null,
    cod_usuario:null,
    id_link:null,
    num_telefone_celular: null,
    pdv: null,
    cpf:null,
    url:null,
    url_ativa:false,
    tipo_selfie:null,
    tipo_captura:null,
    origem_processo: null,
    licenca_kofax:null,
    loadingStatus:false,
    titulo: null,
    tip_captura: null,
    tipo_doc:null,
    tip_solicitacao:null,
    url_webhook:null,
    componente_selfie_carregado:false,
    componente_doc_carregado:false,
    cnh_digital_base:null,
    link_codigo: null,
    link_hrefer: null,
    link_origem: null,
    liveness:null, // 1 - 2D 2 - Facetec 3 - LivenessSerasa,4 - Caf
    token_caf:null,
    is_caf:false,
    token_serasa:null,
    ind_api_n1:null,
    t1n:null,
    tempo_resposta:null,
    dados1N:null,
    resposta1N:null, //1 - APROVADO 2- REPROVADO 4- CAPTURAR DOCUMENTOS -1 FALHA
};

const state = initialState;

const mutations = {
    DEFINIR_LINK_VALIDO(state, payload){
        Object.assign(state, payload);
        state.dados1N = sessionStorage.getItem('dados1N');
        if(state.dados1N){
            try{
                let d = jwtDecode(state.dados1N);
                state.resposta1N = d.ind_capturar_doc;
            }catch (e){
                state.resposta1N = true;
            }
        }
        state.is_caf = (state.liveness == 4);
    },
    DEFINIR_URL_ATIVA(state,urlAtiva){
        state.url_ativa = Boolean(urlAtiva);
    },
    RESET_STATE(state) {
        state = initialState;
    },
    LOADING_STATUS(state,status){
        state.loadingStatus = Boolean(status);
    },
    SET_TITULO(state,titulo){
        state.titulo = titulo;
    },
    DEFINIR_TIPO_DOC(state,tipo){
        state.tipo_doc = tipo;
    },
    DEFINIR_COMPONENTE_SELFIE_CARREGADO(state,status){
        state.componente_selfie_carregado = Boolean(status);
    },
    DEFINIR_COMPONENTE_DOC_CARREGADO(state,status){
        state.componente_doc_carregado = Boolean(status);
    },
    CNH_DIGITAL(state, base64pdf){
        state.cnh_digital_base = base64pdf;
    },
    RESPOSTA_BASE_1N(state,{ response, resultado }){
        state.dados1N = response;
        state.resposta1N = resultado;
        sessionStorage.setItem('dados1N',response);
    },
    LIMPAR_DADOS_SELFIE(state){
        state.dados1N = null;
        sessionStorage.removeItem('s');
        sessionStorage.removeItem('selfie_msg');
        sessionStorage.removeItem('selfie_id');
        sessionStorage.removeItem('dados1N');
    }
};

const actions = {
    resetState({commit}){
        commit('RESET_STATE');
    },
    recuperarDadosLinkMeuVivo({commit},payload) {
        return new Promise(((resolve, reject) => {
            let captura = new CapturaService();
            captura.recuperarDadosLinkMeuVivo(payload.codigo,payload.hrefer,payload.origem)
                .then(res => {
                    if(res.type === captura.types.error){
                        reject(res.description);
                    }
                    if(res.data.length === 0){
                        reject('Dados do link não encontrados');
                    }
                    let tipo_doc = sessionStorage.getItem('tipd');
                    if(tipo_doc){
                        res.data.tipo_doc = atob(tipo_doc);
                    }

                    state.link_codigo = payload.codigo;
                    state.link_hrefer = payload.hrefer;
                    state.link_origem = payload.origem;

                    commit('DEFINIR_LINK_VALIDO', res.data);
                    resolve();
                }).catch(e => reject('Falha ao recuperar dados do link'));
        }));
    },
    setLoadingStatus({commit},status){
        commit('LOADING_STATUS',status);
    },
    setUrlAtiva({commit},status){
        commit('DEFINIR_URL_ATIVA',status);
    },
    setTitulo({commit},titulo){
        commit('SET_TITULO',titulo);
    },
    setTipoDoc({commit},tipo){
        commit('DEFINIR_TIPO_DOC',tipo);
    },
    definirComponenteSelfieCarregado({commit},status){
        commit('DEFINIR_COMPONENTE_SELFIE_CARREGADO',status);
    },
    definirComponenteDocCarregado({commit},status){
        commit('DEFINIR_COMPONENTE_DOC_CARREGADO',status);
    },
    setCNHDigital({commit},base64pdf){
        commit('CNH_DIGITAL',base64pdf);
    },
    definirResposta1N({commit},{ response, resultado }){
        commit('RESPOSTA_BASE_1N',{ response, resultado });
    },
    limparDadosSelfie({commit}){
        commit('LIMPAR_DADOS_SELFIE');
    }
};

const getters = {
    loadingStatus(state) {
        return state.loadingStatus;
    },
    urlStatus(state) {
        return state.url_ativa;
    },
    dados(state){
        return state;
    },
    tipoCaptura(state){
        return parseInt(state.tip_captura);
    },
    tipoDoc(state){
        return state.tipo_doc;
    },
    getUser(state){
        return state.cod_usuario;
    },
    getUrlRetorno(state){
        return state.URLRETORNO;
    },
    getUrlWebhook(state){
        return state.url_webhook;
     },
    origemProcesso(state){
        return state.origem_processo;
    },
    isJornadaCompleta(state){
        return state.tip_captura == 1 || state.ind_api_n1 == 1 ? true : false;
    },
    componenteSelfieCarregado(state){
        return state.componente_selfie_carregado;
    },
    componenteDocCarregado(state){
        return state.componente_doc_carregado;
    },
    dados1N(state){
        return state.dados1N;
    },
    indApiN1(state){
        return parseInt(state.ind_api_n1);
    },
    resposta1N(state){
        return state.resposta1N;
    },
    tempoResposta(state){
        return state.tempo_resposta;
    }
};
export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters
})



// WEBPACK FOOTER //
// ./src/store/store.js